module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/239.a19fdb30.png";